import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Checkbox, TableCell, TableRow } from '@mui/material';
import { withTranslation } from 'react-i18next';
import { AssignmentInd, Info, LabelImportant } from '@mui/icons-material';
import { BoxWrapper, OfferNumberWrapper } from '../ResponsibleChangeStyles';

const ResponsibleChangeOfferItem = ({ item, onAllocateOffers, selectedOfferList }) => {
  const handleCheckBoxChange = useCallback(
    event => {
      const value = event.target.checked;
      onAllocateOffers(item, value);
    },
    [item, onAllocateOffers]
  );

  return (
    <TableRow>
      <TableCell>
        <FormControlLabel
          control={
            <Checkbox
              id={'offerResponsibleChange_isSelected'}
              checked={
                selectedOfferList.find(offer => offer.documentId === item.documentId && offer.siteId === item.siteId)
                  ? true
                  : false || false
              }
              onChange={handleCheckBoxChange}
              color='primary'
              name='isAssigned'
              size='small'
            />
          }
        />
      </TableCell>
      <TableCell>
        <BoxWrapper>
          <LabelImportant />
          <OfferNumberWrapper>{item.offerNumber}</OfferNumberWrapper>
        </BoxWrapper>
      </TableCell>
      <TableCell>
        <BoxWrapper>
          {item.clientName && <AssignmentInd />}
          {item.clientName}
        </BoxWrapper>
      </TableCell>
      <TableCell>
        <BoxWrapper>
          <Info />
          {item.stateName}
        </BoxWrapper>
      </TableCell>
      <TableCell>
        <BoxWrapper>
          {item.responsibleName && <Info />}
          {item.responsibleName}
        </BoxWrapper>
      </TableCell>
      <TableCell>
        <BoxWrapper>
          {item.dealerName && <Info />}
          {item.dealerName}
        </BoxWrapper>
      </TableCell>
    </TableRow>
  );
};

ResponsibleChangeOfferItem.propTypes = {
  t: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  onAllocateOffers: PropTypes.func.isRequired,
  selectedOfferList: PropTypes.array
};

export default withTranslation()(ResponsibleChangeOfferItem);
